import { AuthUserStore, UserState } from '@arc/arc-shared-frontend';
import { createSelector } from '@ngrx/store';

export const selectAuthUserToken = createSelector(
  AuthUserStore,
  (auth: UserState) => auth?.user.accessToken || '',
);
